export default __webpack_public_path__ + "static/media/text-input-spinner.104cd9d1.svg";